import { isNil } from 'lodash';
import { API } from '@shared/types/api';

export function isLowCodeViewTemplate({
  viewTemplate,
}: {
  viewTemplate?: API.ViewTemplateFragment;
}): boolean {
  switch (viewTemplate?.subtype) {
    case 'TABLE':
    case 'LIST':
      return false;
    case 'CALENDAR':
      return isNil(viewTemplate.calendarDateComponentId);
    case 'BOARD':
      return !viewTemplate.customSortingEnabled;
    default:
      return true;
  }
}
